module.exports = {
  dish1: {
    name: "Sandwich 1",
    description: "Insert Sandwich 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Sandwich 2",
    description: "Insert Sandwich 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Sandwich 3",
    description: "Insert Sandwich 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Sandwich 4",
    description: "Insert Sandwich 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Sandwich 5",
    description: "Insert Sandwich 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Sandwich 6",
    description: "Insert Sandwich 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Sandwich 7",
    description: "Insert Sandwich 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Sandwich 8",
    price: 4400,
    description: "Insert Sandwich 8 description",
    status: "available"
  },
  dish9: {
    name: "Sandwich 9",
    price: 3300,
    description: "Insert Sandwich 9 description",
    status: "available"
  },
  dish10: {
    name: "Sandwich 10",
    price: 3900,
    description: "Insert Sandwich 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/FoodTruckMafia.js